import viewSchedule from '../../../../../assets/images/featured_actions/viewSchedule.png';
import watchTrailer from '../../../../../assets/images/featured_actions/watchTrailer.png';
import listenToMusic from '../../../../../assets/images/featured_actions/listenToMusic.png';
import call from '../../../../../assets/images/featured_actions/call.png';
import place from '../../../../../assets/images/featured_actions/place.png';
import addToBalance from '../../../../../assets/images/featured_actions/addToBalance.png';
import order from '../../../../../assets/images/featured_actions/order.png';
import shop from '../../../../../assets/images/featured_actions/shop.png';
import membershipBenefits from '../../../../../assets/images/featured_actions/membershipBenefits.png';
import bookAppointment from '../../../../../assets/images/featured_actions/bookAppointment.png';
import bookCar from '../../../../../assets/images/featured_actions/bookCar.png';
import bookFlight from '../../../../../assets/images/featured_actions/bookFlight.png';
import bookStay from '../../../../../assets/images/featured_actions/bookStay.png';
import viewOffersRewards from '../../../../../assets/images/featured_actions/viewOffersRewards.png';

export const FEATURED_ACTION_ASSETS = {
  viewSchedule,
  watchTrailer,
  listenToMusic,
  call,
  place,
  addToBalance,
  order,
  shop,
  membershipBenefits,
  bookAppointment,
  bookCar,
  bookFlight,
  bookStay,
  viewOffersRewards,
} as const;
